// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "91f86153188764360f4344a2cedcc9dd" + ".css";
};